import { HarvestTimeEntry } from "~/types"
import { HarvestButton } from "../HarvestButton/HarvestButton"
import { useUpdateHarvestEntryIsRunning } from "~/hooks/harvest"
import "./HarvestControls.scss"
import { IconPlay } from "../Icons/IconPlay"
import { IconPause } from "../Icons/IconPause"
import classNames from "classnames"

export function HarvestControls({
  entry,
  onUpdated,
}: {
  entry: HarvestTimeEntry
  onUpdated: () => void
  trackerLink: string
}) {
  const { mutate: updateEntryIsRunning, isPending } =
    useUpdateHarvestEntryIsRunning()

  return (
    <div
      className={classNames("HarvestControls", {
        "HarvestControls--running": entry.is_running,
      })}
    >
      <div className="HarvestControls__side">
        <p className="HarvestControls__client">{entry.client}</p>
        <p className="HarvestControls__project">{entry.project}</p>
      </div>
      <HarvestButton
        aria-label={entry.is_running ? "Pause" : "Start"}
        className="HarvestControls__toggle"
        isLoading={isPending}
        onClick={() => {
          updateEntryIsRunning(
            {
              entryId: entry.id,
              isRunning: !entry.is_running,
            },
            { onSuccess: () => onUpdated() },
          )
        }}
      >
        {entry.is_running ? <IconPause /> : <IconPlay />}
      </HarvestButton>
      <div className="HarvestControls__side">
        <p className="HarvestControls__task">{entry.task}</p>
        <p className="HarvestControls__notes">
          {entry.reference_link ? (
            <a
              href={entry.reference_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {entry.notes}
            </a>
          ) : (
            entry.notes
          )}
        </p>
      </div>
    </div>
  )
}
